module.exports = __webpack_public_path__ + "static/media/user_circle_outline.be293338.svg";